import React from 'react'
import { connect } from 'react-redux'
import { withSiteData } from 'react-static'

import ProductList from '../components/ProductList'
import {deleteProduct} from '../actions/products'

const Products = withSiteData(({products, deleteProduct}) =>
  <React.Fragment>
    <div className="row">
      <div className="col-sm-12">
        <div className="page-title-box">
          <h4 className="page-title">Produkte</h4>
          <div className="clearfix"/>
        </div>
      </div>
    </div>

    <div className="row">
      <div className="col-12">
        <ProductList
          products={products.items}
          deleteProduct={deleteProduct}/>
      </div>
    </div>
  </React.Fragment>
)

export default connect(
  state => ({
    products: state.products
  }),
  dispatch => ({
    deleteProduct: (id) => dispatch(deleteProduct(id))
  })
)(Products)



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/containers/Products.js